export default {
  container: {
    width: '100%',
    padding: '7px 12px 6px 12px',
    border: (theme) => `1px solid ${theme.palette.grays.gray300}`,
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    height: '39px',
    borderRadius: '4px',
    color: (theme) => theme.palette.grays.gray700,
    forntSize: '14px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: (theme) => `${theme.palette.grays.lightestGray}`,
      borderColor: (theme) => `${theme.palette.grays.gray300}`,
    },
  },
  color: {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    border: (theme) => `1px solid ${theme.palette.grays.gray200}`,
  },
};
